"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssignProductDetail = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var hsTransfer_1 = require("../../model/hsTransfer");
var service_1 = require("../../../library/base/service");
var AssignProductDetail = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(AssignProductDetail, _super);
    function AssignProductDetail() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '可转让产品详情页接口';
        _this.code = '105010';
        _this.desc = '可转让产品详情页接口';
        _this.requestParams = new hsTransfer_1.AssignProductDetailRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return AssignProductDetail;
}(service_1.BaseService));
exports.AssignProductDetail = AssignProductDetail;
//# sourceMappingURL=assignProductDetail.js.map